import SidebarLayout from "@/components/feature/SidebarLayout";
import { useScrollReveal, getRevealClass } from "@/hooks/useScrollReveal";

const categories = [
  { icon: "ri-leaf-line", title: "農産物", desc: "大分県産カボス・サンクイーンなど、こだわりの農産物をお届けします。" },
  { icon: "ri-t-shirt-line", title: "アパレル", desc: "OL Companyオリジナルのアパレル商品。地域の魅力をデザインに込めました。" },
  { icon: "ri-gift-line", title: "ギフト", desc: "大切な方へのギフトにも最適な商品を取り揃えています。" },
];

export default function EC() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <SidebarLayout breadcrumbs={[{ label: 'ネットショップ' }]}>

      {/* Hero */}
      <section className="px-4 md:px-6 lg:px-10 mb-10">
        <div className="relative w-full h-[320px] sm:h-[400px] md:h-[500px] lg:h-[580px] overflow-hidden rounded-2xl">
          <img
            src="https://storage.googleapis.com/studio-design-asset-files/projects/EXaw2V5pqD/s-4080x3072_v-frms_webp_69b5475f-7644-40f8-b9bd-89073b834090_small.webp"
            alt="ネットショップ"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-black/25" />
          <div ref={ref} className={`absolute inset-0 flex flex-col items-center justify-center z-10 ${getRevealClass(isVisible)}`}>
            <h1
              className="text-3xl sm:text-4xl md:text-5xl font-bold text-white tracking-wide"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              ネットショップ
            </h1>
            <p
              className="text-xs sm:text-sm text-white/80 mt-2 tracking-wider"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              ec shop
            </p>
          </div>
        </div>
      </section>

      {/* Content Card */}
      <div className="px-4 md:px-6 lg:px-10 pb-16 md:pb-24">
        <div className="bg-white rounded-2xl p-8 md:p-12 lg:p-16">
          <div className="max-w-3xl mx-auto">
            {/* Overview */}
            <div
              className="text-base md:text-lg text-gray-800 leading-[2.2] tracking-wide mb-10"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              <p className="mb-6">
                弊社オリジナルブランド商品を開発し、ローカルの輝きを世界にシェアしていきます。
              </p>
              <p className="mb-6">
                ファーム事業で生産したカボスのみならず、メディア部門と連携したアパレルの販売も自社ECサイト等で行います。
              </p>
              <p>
                大分の豊かな自然と文化から生まれたプロダクトを、ぜひお手に取ってご覧ください。
              </p>
            </div>

            {/* Shop Button */}
            <div className="flex justify-end mb-16">
              <a
                href="https://olcompany.base.shop/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-8 py-3 bg-[#3D72D9] text-white text-sm font-medium rounded-full hover:bg-[#2e5ab5] transition-colors whitespace-nowrap"
              >
                ショップを見る <i className="ri-external-link-line" />
              </a>
            </div>

            {/* Categories */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 pt-10 border-t border-gray-100">
              {categories.map((item) => (
                <div key={item.title}>
                  <div className="w-10 h-10 flex items-center justify-center mb-4">
                    <i className={`${item.icon} text-2xl text-black`} />
                  </div>
                  <h3
                    className="text-base font-bold text-black mb-2 tracking-wide"
                    style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                  >
                    {item.title}
                  </h3>
                  <p
                    className="text-sm text-gray-600 leading-relaxed"
                    style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                  >
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </SidebarLayout>
  );
}